import Record from "./Record";
import Play from "./Play";

function MusicSession() {
    return <span id="musicSession">
                <Record/>
                <Play/>
           </span>
}

export default MusicSession;
